<!-- Navbar -->
<HomeNavBar @toggleMenu="showMenu = !showMenu" @new_report="addReportToHome" @new_temp_post="addTemporaryPost"
  @active-profile-loaded="onActiveProfileLoaded" />
<section>
  <div class="row">
    <div class="col-md-3">
      <AllGroups />
      <AllPortals @portal_profile="portalProfile" @portal_selected="fetchPostsByPortal"
        @portalAccepted="handlePortalAccepted" ref="portals" :portal_admin="portal_admin"
        @sub_portals="handle_sub_portals" @clear_reports="clear_reports_filter" />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-12 padpro-screen">
      <div class="card rounded bg-white border-0 mt-1">
        <div class="border-bottom pb-3 mx-3 mt-4">
<h3 class="fw-bold mb-1 text-dark">
  {{ $route.params.group_name }}
</h3>

          <div class="d-flex align-items-center flex-wrap gap-3 text-xs">

            <span v-if="$route.params.is_public === 'false'"
              class="badge bg-light text-dark border rounded-pill d-inline-flex align-items-center px-2 py-1 fw-normal">
              <i class="bx bxs-lock-alt text-danger me-1 fs-6"></i>
              <span v-if="school_domain">Private</span>
              <span v-else>Private Group</span>
            </span>

            <span v-else
              class="badge bg-light text-dark border rounded-pill d-inline-flex align-items-center px-2 py-1 fw-normal">
              <i class="bx bx-globe text-success me-1 fs-6"></i>
              <span v-if="school_domain">Public</span>
              <span v-else>Public Group</span>
            </span>

            <span class="d-inline-flex align-items-center" title="View Members">
              <i class='bx bxs-user-account fs-5 me-1'></i>
              <span class="fw-bold text-dark me-1">{{ group_members.length }}</span> Members
            </span>

          </div>
        </div>


        <div class="col h-100 overflow-auto mt-2">
          <!-- iPad (md) & Desktop View: Centered Tabs -->
          <div class="card-header bg-transparent rounded btn-primary">
            <div class="scrollable-tabs">
              <ul class="nav nav-tabs text-xxs" id="pills-billib-tab" role="tablist">
                <li class="" role="presentation">
                  <button class="nav-link fs-xsm fw-500 px-4" :class="{ active: activeTab === 'your_feed' }"
                    @click="activeTab = 'your_feed'" id="tab-your-feed" data-bs-toggle="tab"
                    data-bs-target="#normal_loans_info" type="button" role="tab" aria-controls="normal_loans_info"
                    :aria-selected="activeTab === 'your_feed'">Your Feed</button>
                </li>
                <li class="" role="presentation">
                  <button class="nav-link fs-xsm fw-500 px-4" :class="{ active: activeTab === 'voice' }"
                    @click="activeTab = 'voice'" id="tab-your-voice" data-bs-toggle="tab"
                    data-bs-target="#top_loans_info" type="button" role="tab" aria-controls="top_loans_info"
                    :aria-selected="activeTab === 'voice'">Your Voice</button>
                </li>

              </ul>
            </div>
          </div>
        </div>
      </div>



      <div class="row">
        <div class="post-section h-150 full-width-mobile overflow-auto scrollable-container padding-x py-1 mt-1">
          <div class="tab-content full-width-mobile w-100" id="pills-tabContent">
            <div class="tab-pane fade show active py-3 full-width-mobile padding-x" id="normal_loans_info"
              role="tabpanel" aria-labelledby="normal_loans_tab">
              <GroupFeed v-if="token_exists && activeTab === 'your_feed'" :key="activeTab"
                @new_group_feed="add_new_group_feed" :active-profile="activeProfile" />
              <div class="d-flex align-items-center temporary-post" v-if="temporaryPost" id="temp-post">
                <p class="text-xxs fw-bold">{{ temporaryPost.report_name }} - Posting...</p>
                <div class="spinner-border ms-auto  text-secondary" role="status" aria-hidden="true"></div>
              </div>
              <div v-else-if="is_feed_loading && group_feeds.length === 0" class="text-center py-5 w-100">
                <div class="spinner-border text-secondary" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2 mb-0 text-muted">Loading feeds...</p>
              </div>
              <!--  -->
              <div v-else>
                <div ref="scrollContainer" @scroll="handleScroll" class="scrollable-container mb-5">
                  <div v-if="group_feeds.length > 0">
                    <div v-for="feed in group_feeds" :key="feed.id" :id="'post-' + feed.id"
                      class="card card-hover mb-4 p-3 d-flex flex-column border-bottom rounded border-0 full-width-mobile shadow">
                      <div class="row">
                        <div class="col">
                          <div class="d-flex align-items-start">
                            <div
                              class="user-avatar d-flex align-items-center justify-content-center overflow-hidden rounded-circle bg-light border">
                              <img v-if="feed?.creater?.profile_picture" :src="feed.creater.profile_picture"
                                alt="User Avatar" class="w-100 h-100 object-fit-cover">
                              <i v-else class="bi bi-person-circle fs-2 text-primary"></i>
                            </div>
                            <div class="flex-grow-1">
                              <div class="d-flex justify-content-between align-items-start">
                                <div class="pe-2">
                                  <p class="fw-500 mb-1 lh-base small">
                                    <span>{{ feed.creater.first_name }} {{ feed.creater.last_name }}</span>
                                  </p>
                                  <p class="text-muted small mb-0 d-flex align-items-center gap-1">
                                    <span v-if="feed.date_created">
                                      <i class="bx bxs-stopwatch"></i>
                                      {{ feed.date_created }}
                                    </span>
                                  </p>
                                </div>
                                <div class="dropstart ms-2" @click.stop
                                  v-if="String(feed.creater.id) === String(user_id) && token_exists ">
                                  <a href="" class="text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                    aria-expanded="false">
                                    <i class="bi bi-three-dots-vertical"></i>
                                  </a>
                                  <ul class="dropdown-menu dropdown-menu-end lh-sm"
                                    aria-labelledby="dropdownMenuButton">
                                    <li>
                                      <a class="dropdown-item small fw-bold" href="" data-bs-toggle="modal"
                                        data-bs-dismiss="dropdown" data-bs-target="#edit_feed_modal"
                                        @click="edit_feed(feed)"
                                        v-if="feed.total_comments === 0 && feed.total_likes === 0">
                                        <i class="bx bxs-edit fs-6"></i> Edit
                                      </a>
                                    </li>
                                    <li>
                                      <a class="dropdown-item small fw-bold" href=""
                                        @click.prevent="deleteGroupFeed(feed.id)">
                                        <i class="bx bxs-trash-alt fs-6"></i>Delete
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>

                          <p class="fw-500 text-xxs mt-2">{{ feed.name }}</p>

                          <div class="quill-wrapper">

                            <div v-html="feed.description" class="ql-editor quill-content fs-6 lh-lg"></div>

                            <span v-if="shouldShowReadMore(feed)" class="text-secondary cursor-pointer text-xxs ms-1"
                              @click="toggleFeedReadMore(feed.id)">
                              <!-- Check if it should show 'Read More' and render the icon accordingly -->
                              {{ isFeedExpanded(feed.id) ? 'Read Less' : 'Read More' }}
                              <i v-if="!isFeedExpanded(feed.id)" class='bx bx-down-arrow-circle'></i>
                              <i v-else class='bx bx-up-arrow-circle'></i>
                            </span>
                          </div>
                          <div v-if="getCarouselImages(feed).length > 0" class="report-carousel mb-3">
                            <div :id="'carousel-' + feed.id" class="carousel slide" data-bs-ride="false">

                              <div v-if="getCarouselImages(feed).length > 1" class="carousel-indicators">
                                <button v-for="(image, i) in getCarouselImages(feed)" :key="'ind-' + i" type="button"
                                  :data-bs-target="'#carousel-' + feed.id" :data-bs-slide-to="i"
                                  :class="{ active: i === 0 }" aria-current="i === 0 ? 'true' : undefined">
                                </button>
                              </div>

                              <div class="carousel-inner">
                                <div v-for="(image, i) in getCarouselImages(feed)" :key="'img-' + i"
                                  :class="['carousel-item', { active: i === 0 }]">

                                  <img :src="image.file.file_url" class="d-block w-100 rounded-5"
                                    @click="display_comment_modal(feed)" />
                                </div>
                              </div>

                              <div v-if="getCarouselImages(feed).length > 1">
                                <button class="carousel-control-prev" type="button"
                                  :data-bs-target="'#carousel-' + feed.id" data-bs-slide="prev">
                                  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                </button>
                                <button class="carousel-control-next" type="button"
                                  :data-bs-target="'#carousel-' + feed.id" data-bs-slide="next">
                                  <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                </button>
                              </div>
                            </div>
                          </div>




                          <!-- Like and comment buttons -->
                          <div
                            class="d-flex justify-content-between align-items-center border-top border-bottom px-2 py-1 flex-wrap mb-2">
                            <div class="d-flex align-items-center me-3">
                              <span v-if="!likedReports[feed.id]" class="d-flex align-items-center text-primary pointer"
                                @click.stop="likeFeed(feed)">
                                <i class="bi bi-hand-thumbs-up text-black pointer"></i>
                                <span class="text-purple fw-500 text-xxs mx-1">Like</span>
                              </span>

                              <span v-else class="d-flex align-items-center fw-500 pointer text-primary"
                                @click.stop="unlikeFeed(feed)">
                                <i class="bi bi-hand-thumbs-up-fill text-black pointer text-xs"></i>
                                <span class="text-xxs fw-500">Unlike</span>
                              </span>
                            </div>
                            <!-- Comment Input -->
                            <div
                              :class="`d-flex align-items-center me-3  ${!feed.can_comment ? 'comment-disabled' : 'pointer'}`"
                              @click="activeCommentReportId = feed.id">
                              <i class="bi bi-chat fw-bold pointer text-xs"></i>
                              <span class="mx-1 text-xs fw-500">Comment</span>
                            </div>

                            <div class="mb-3 me-2 menu mt-1" @click.stop>
                              <input type="checkbox" :id="'menu-open-' + feed.id" class="menu-open" name="menu-open" />
                              <span><label :for="'menu-open-' + feed.id"
                                  class="menu-open-button text-xs d-flex align-items-center" @click="boon"><i
                                    class="bi bi-share"></i>
                                  <span class="mx-1 fw-500">Share</span></label></span>

                              <a @click="copyFeedLinkToClipboard(feed)" class="menu-item ">
                                <span @click="closeFeedMenu(feed.id)"><i
                                    class="bi bi-link fs-4 copy text-primary text-xxs"></i></span>
                              </a>
                              <a :href="'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(baseUrl(feed,'feed'))"
                                target="_blank" class="menu-item facebook-share-btn" @click="closeFeedMenu(Feed.id)">
                                <i class="bi bi-facebook"></i>
                              </a>
                              <a :href="'https://twitter.com/intent/tweet?url=' + encodeURIComponent(baseUrl(feed,'feed'))"
                                target="_blank" class="menu-item twitter-share-btn" @click="closeFeedMenu(Feed.id)">
                                <i class="bi bi-twitter-x"></i>
                              </a>
                              <a :href="'mailto:?subject=Check%20this%20out&body=' + encodeURIComponent(baseUrl(feed,'feed'))"
                                target="_blank" class="menu-item gmail-share-btn" @click="closeFeedMenu(Feed.id)">
                                <i class="bi bi-google"></i>
                              </a>
                              <a :href="'https://www.linkedin.com/sharing/share-offsite/?url=' + encodeURIComponent(baseUrl(feed,'feed'))"
                                target="_blank" class="menu-item linkedin-share-btn" @click="closeVFeedMenu(Feed.id)">
                                <i class="bi bi-linkedin"></i>
                              </a>
                              <a :href="'https://api.whatsapp.com/send?text=' + encodeURIComponent(baseUrl(feed,'feed'))"
                                target="_blank" class="menu-item whatsapp-share-btn" @click="closeFeedMenu(Feed.id)">
                                <i class="bi bi-whatsapp"></i>
                              </a>
                              <a :href="'https://t.me/share/url?url=' + encodeURIComponent(baseUrl(feed,'feed'))"
                                target="_blank" class="menu-item telegram-share-btn" @click="closeFeedMenu(Feed.id)">
                                <i class="bi bi-telegram"></i>
                              </a>

                              <div aria-live="polite" aria-atomic="true" class="position-fixed custom-toast">
                                <div id="copyToast" class="toast align-items-center text-bg-success border-0"
                                  role="alert" aria-live="assertive" aria-atomic="true">
                                  <div class="d-flex">
                                    <div class="toast-body">
                                      Link copied to clipboard!
                                    </div>
                                    <button type="button" class="btn-close btn-close-white me-2 m-auto"
                                      data-bs-dismiss="toast" aria-label="Close"></button>
                                  </div>
                                </div>
                              </div>


                            </div>
                          </div>
                          <div class="d-flex align-items-center border rounded-pill mb-3 p-0"
                            v-if="activeCommentReportId === feed.id">
                            <img :src="feed.creater.profile_picture" alt="User" class="rounded-circle mx-2" width="32"
                              height="32">

                            <input type="text" class="form-control border-0 rounded" v-model="commentText"
                              id="comment_text_area" placeholder="Write a comment" @input="onCommentInput" />

                            <div class="d-flex align-items-center pe-2">
                              <button class="btn btn-sm text-xxs border-0" type="button"
                                @click="submit_comment(feed.id)"
                                :disabled="!commentText || commentText.trim().length === 0">
                                <i class="bi bi-send-fill fs-5"
                                  :class="commentText && commentText.trim().length > 0 ? 'text-primary' : 'text-primary opacity-50'"></i>
                              </button>
                            </div>
                          </div>

                          <!-- Suggestion Dropdown -->
                          <!-- <div v-if="showSuggestions && filteredUsers.length > 0" class="suggestions-dropdown modal-body-scroll">
  <div v-for="user in filteredUsers" :key="user.id" class="suggestion-item" @mousedown.prevent="selectUser(user)">
    {{ user.full_name }}
  </div>
</div> -->
                          <Comments :comments="feed.comments" :report-id="feed.id" @add-comment="handleAddComment"
                            :activeProfile="activeProfile" />



                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-else class="text-center py-3">
                    <p class="mt-2 mb-0 text-muted">No feeds available.</p>
                  </div>

                  <div ref="infiniteScrollSentinel" class="sentinel"></div>
                </div>
                <div v-if="is_feed_loading" class="loading">Loading...</div>
              </div>
            </div>
            <div class="tab-pane fade" id="top_loans_info" role="tabpanel" aria-labelledby="top_loans_tab">
              <SurveyView :active_profile="activeProfile" />

            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-3 d-none d-xl-block bg-transparent">
      <div class="card bg-transparent border rounded shadow-sm mt-1 d-none d-xl-block me-2">
        <div class="card-header bg-transparent border-0 pt-3 pb-2 d-flex border-bottom justify-content-between align-items-center">

          <h6 class="mb-0 fw-bold text-dark d-flex align-items-center gap-2">
            <i class="bx bxs-group text-primary fs-5"> </i> <span v-if="school_domain">{{group_members.length }} Class members</span>
            <span v-else>{{group_members.length }} Group members</span>
          </h6>

          <div class="d-flex align-items-center gap-3">

            <button v-if="isCreator && selectedMembers.length" @click="removeSelectedMembers"
              class="btn btn-sm btn-danger d-flex align-items-center gap-2 px-3 rounded-pill shadow-sm transition-all"
              title="Delete selected members">
              <i class="bi bi-trash-fill"></i>
              <span class="text-xs fw-bold">Delete ({{ selectedMembers.length }})</span>
            </button>

            <div v-if="!getGroupMember(group_members)?.has_exited" class="dropdown dropstart">
              <a href="#" class="text-secondary p-1 d-flex align-items-center" id="dropdownMenuButton"
                data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-three-dots-vertical fs-5 text-dark"></i>
              </a>

              <ul class="dropdown-menu shadow-sm border-0 mt-2 py-2 rounded-3" aria-labelledby="dropdownMenuButton">

                <li v-if="isCreator || user_details.user_role === 'admin'">
                  <a class="dropdown-item text-xs py-2 d-flex align-items-center gap-2" href="#" data-bs-toggle="modal"
                    data-bs-target="#add_group_member_modal" @click.prevent="selectedUserIds = []">
                    <i class="bi bi-person-plus fs-6 text-primary"></i>
                    <span class="fw-500">Add Member(s)</span>
                  </a>
                </li>

                <li v-if="isCreator || user_details.user_role === 'admin'">
                  <a class="dropdown-item text-xs py-2 d-flex align-items-center gap-2" href="#" data-bs-toggle="modal"
                    data-bs-target="#delete_group_member_modal" @click.prevent="selectedUserIds = []">
                    <i class="bi bi-person-dash fs-6 text-danger"></i>
                    <span class="fw-500">Remove Member(s)</span>
                  </a>
                </li>

                <li
                  v-if="!isCreator && user_details.user_role !== 'admin' && !getGroupMember(group_members)?.has_exited">
                  <hr class="dropdown-divider my-1">
                  <a class="dropdown-item text-xs py-2 d-flex align-items-center gap-2 text-warning" href="#"
                    @click.prevent="showExitMode">
                    <i class="bi bi-box-arrow-right fs-6"></i>
                    <span class="fw-500">Exit Group</span>
                  </a>
                </li>

              </ul>
            </div>
          </div>

        </div>
        <div class="table-container ">
          <table v-if="group_members.length" class="table mb-0">
            <tbody>
              <tr v-for="member in group_members" :key="member.id" class="hover-row border-0">
                <td class="border-0">
                  <span class="text-decoration-none text-dark d-block w-100">
                    <label class="cursor-pointer mb-0 d-flex align-items-center w-100">
                      <input type="checkbox" v-if="deleteMode && member.user.id != user_id" v-model="selectedMembers"
                        :value="member.user.id" class="me-2" @change="handleFileUpload" />

                      <a
                        class="rounded-circle d-flex justify-content-center align-items-center bg-yellow p-1 shadow-sm">
                        <i class='bx bx-user text-change fs-6'></i>
                      </a>

                      <span class="text-xs fw-500 mx-2 color-blue text-truncate">
                        {{ member.user.first_name }} {{ member.user.last_name }}
                      </span>

                      <span v-if="member.user.id === group_creator_id"
                        class="text-muted ms-auto text-xxs px-2 py-1  fw-normal">
                        Owner
                      </span>
                    </label>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <p v-else class="text-secondary text-xs text-center mt-3">
            No Group members Available
          </p>
        </div>
      </div>
    </div>
  </div>
  <StickyNav />

  <div class="offcanvas offcanvas-start" tabindex="-1" id="group_members" aria-labelledby="group_members_label">
    <div class="offcanvas-header">
      <h5 class="offcanvas-title" id="groups_label"></h5>
      <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <h6 class='text-start mx-1 d-flex justify-content-between align-items-center'>Group members
        <div v-if="!deleteMode" class="dropstart">
          <a href="" class="fw-bold text-dark" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
            <i class="bi bi-three-dots-vertical"></i><span class="small"></span>
          </a>
          <ul class="dropdown-menu custom-dropdown" aria-labelledby="dropdownMenuButton">
            <li v-if="isCreator">
              <a class="dropdown-item text-xs border-bottom" @click="showDeleteMode">
                <i class='bx bxs-trash-alt fs-6'></i> Delete Member(s)
              </a>
            </li>
            <li>
              <a class="dropdown-item text-xs" @click="showExitMode">
                <i class="bi bi-door-open"></i> Exit Group
              </a>
            </li>
          </ul>
        </div>
        <i class="bi bi-trash text-danger fs-4" @click="removeSelectedMembers" v-if="selectedMembers.length"></i>
      </h6>
      <hr />

      <!-- Create Group Modal -->
      <div class="table-container ">
        <table v-if="group_members.length" class="table mb-0">
          <tbody>
            <tr v-for="member in group_members" :key="member.id" class="hover-row border-0">
              <td class="border-0">
                <span class="text-decoration-none text-dark">
                  <p class="portal-icon mb-0 d-flex align-items-center">
                    <input type="checkbox" v-if="deleteMode && member.user.id != user_id" v-model="selectedMembers"
                      :value="member.user.id" class="me-2" @change="handleFileUpload" />
                    <a class="rounded-circle bg-yellow p-1 shadow-sm color-purple">
                      <i class='bx bx-user fs-5'></i>
                    </a>
                    <span class="text-xs fw-500 mx-2 color-blue">{{ member.user.first_name }}{{" "}}{{
                      member.user.last_name }}</span>
                  </p>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <p v-else class="text-secondary text-xs text-center">
          No Group members Available
        </p>
      </div>
    </div>
  </div>

  <teleport to="body">
    <div class="modal fade" id="edit_feed_modal" tabindex="-1" aria-labelledby="editGroupFeedModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content rounded shadow scrollable-container">

          <!-- Header -->
          <div class="modal-header bg-primary position-relative">
            <h5 class="modal-title text-white" id="editGroupFeedModalLabel">
              Edit group feed
            </h5>
            <button type="button"
              class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
              data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <!-- Form -->
          <form @submit.prevent="edit_groupFeed" class="p-2">
            <div class="post-content">

              <!-- User Info -->
              <div class="user-info">
                <div class="me-2 ms-1 d-flex align-items-center justify-content-center ">
                  <i class="bi bi-person-circle fs-2 text-dark pointer">

                  </i>
                </div>
                <div>
                  <div class="user-name mb-0">
                    {{ user_details.first_name }} {{ user_details.last_name }}
                  </div>
                </div>
              </div>

              <!-- Allow comments -->
              <div class="d-flex align-items-center mt-2 mb-3">
                <label class="form-label mb-0 me-3 text-xs fw-500">
                  Allow comments:
                </label>
                <div class="form-check comment-switch">
                  <input class="form-check-input" type="checkbox" v-model="group_can_comment" />
                </div>
                <label class="form-check-label text-xxs ms-2">
                  {{ group_can_comment ? 'Yes' : 'No' }}
                </label>
              </div>

              <!-- Description -->
              <div class="textarea-container">
                <QuillEditor theme="snow" v-model="edit_feed_description" ref="quillEditFeedEditorRef"
                  class="quill-editor" placeholder="Edit your post..." toolbar="full" />

                <div v-if="errors.edit_feed_description" class="error-message">
                  {{ errors.edit_feed_description }}
                </div>

                <!-- Existing file preview -->
                <div v-if="editFileName" class="text-xs text-primary fst-italic mt-1">
                  <span class="fw-500">File name:</span> {{ editFileName }}
                </div>

                <div v-if="editFileError" class="text-xs text-danger fst-italic mt-1">
                  {{ editFileError }}
                </div>

                <div v-if="edit_image_preview" class="mt-2">
                  <img :src="edit_image_preview" class="img-fluid rounded" />
                </div>
              </div>

            </div>

            <!-- Add to post -->
            <div class="add-to-post d-flex align-items-center justify-content-between mb-2">
              <div class="add-to-post-text">Add Media</div>

              <div class="d-flex flex-row align-items-center">

                <!-- Files -->
                <label class="file-upload post-option me-2">
                  <i class="bi bi-images icon-photo"></i>/<i class="bi bi-filetype-docx icon-more"></i>
                </label>
                <input type="file" class="file-input d-none" @change="handleEditFileUpload" />

                <!-- Audio -->
                <label class="post-option me-2">
                  <i class="bi bi-music-note-beamed icon-emoji"></i>
                </label>
                <input type="file" accept="audio/*" class="file-input d-none" @change="handleEditAudioUpload" />

                <!-- Record -->
                <button type="button" class="post-option me-2" @click="startRecording" v-if="!isRecording">
                  <i class="bi bi-mic icon-location"></i>
                </button>

                <button type="button" class="post-option me-2" @click="stopRecording" v-if="isRecording">
                  <i class="bx bx-stop icon-location"></i>
                </button>

              </div>
            </div>

            <!-- Submit -->
            <div class="post-button-container mt-3">
              <p v-if="errors.edit_feed_details" class="text-danger text-xs">
                {{ errors.edit_feed_details }}
              </p>
              <div class="d-flex justify-content-end mb-2 mt-3">
                <button class="btn btn-primary rounded-3 shadow-sm fw-bold text-xs" type="submit">
                  Update
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </teleport>



</section>

<GroupFeedCommentModal v-if="comment_modal_visible" :feed_data="feed_data"
  @hide_comment_comment="hide_comment_comment" />


<!-- modal to add group members -->
<teleport to="body">
  <div class="view-portal modal fade " id="add_group_member_modal" tabindex="-1" aria-labelledby="groupMemberLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="groupMemberLabel">Add Group Members</p>
          <!-- Close button on the end with white "X" -->
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <form @submit.prevent="addGroupMembers">
          <div class="modal-body table-responsive table-container p-4">
            <table id="addMembersTable" class="table table-striped table-hover text-xxs align-middle mt-4">
              <thead class="btn-primary text-white">
                <tr>
                  <th scope="col">No</th>
                  <th scope="col">First Name</th>
                  <th scope="col">Last Name</th>
                  <th scope="col">Email</th>

                  <th scope="col">
                    <div class="form-check d-flex align-items-center mb-0 ps-0">
                      <label class="form-check-label fw-bold cursor-pointer me-4 text-white" for="select_all_checkbox">
                        Action
                      </label>
                      <input class="form-check-input cursor-pointer m-0 float-none" type="checkbox"
                        id="select_all_checkbox" :checked="areAllSelected" @change="toggleSelectAll" />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="text-black">
                <tr v-for="(user, index) in members" :key="user.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ user?.first_name }}</td>
                  <td>{{ user?.last_name }}</td>
                  <td>{{ user?.email }}</td>

                  <td class="position-relative text-center">
                    <div class="form-check d-inline-block mb-0">
                      <input class="form-check-input cursor-pointer m-0 float-none" type="checkbox"
                        :id="'group_member_check_' + user.id" :value="user.id" v-model="selectedUserIds" />

                      <label class="form-check-label stretched-link cursor-pointer"
                        :for="'group_member_check_' + user.id"></label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">Add Member(s)</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>

<!-- modal to delete group members -->
<teleport to="body">
  <div class="view-portal modal fade " id="delete_group_member_modal" tabindex="-1" aria-labelledby="groupMemberLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-xxs fw-500" id="groupMemberLabel">Delete Group Members</p>
          <!-- Close button on the end with white "X" -->
          <button type="button" class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal" aria-label="Close">
          </button>
        </div>
        <form @submit.prevent="removeSelectedMembers">
          <div class="modal-body table-responsive">

            <table id="deleteMembersTable" class="table table-hover table-striped text-xxs align-middle">
              <thead class="btn-primary text-white">
                <tr>
                  <th scope="col">No</th>
                  <th scope="col">First Name</th>
                  <th scope="col">Last Name</th>
                  <th scope="col">Email</th>
                  <th scope="col">
                    <div class="form-check d-flex align-items-center mb-0 ps-0">
                      <label class="form-check-label cursor-pointer text-white me-4"
                        for="select_all_checkbox">Action</label>
                      <input class="form-check-input cursor-pointer" type="checkbox" id="select_all_checkbox"
                        :checked="areAllForDeleteSelected" @change="toggleSelectForDeleteAll" />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody class="text-black">
                <tr v-for="(member, index) in filteredMembers" :key="member.user.id">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ member?.user?.first_name }}</td>
                  <td>{{ member?.user?.last_name }}</td>
                  <td>{{ member?.user?.email }}</td>
                  <td class="text-center position-relative">
                    <div class="form-check d-inline-block m-0">
                      <input class="form-check-input cursor-pointer" type="checkbox"
                        :id="'group_member_check_' + member.user.id" :value="member.user.id"
                        v-model="selectedUserIds" />
                      <label class="form-check-label stretched-link cursor-pointer"
                        :for="'group_member_check_' + member.user.id"></label>
                    </div>
                  </td>
                </tr>
                <tr v-if="filteredMembers.length === 0">
                  <td colspan="5" class="text-center text-muted py-3">No members found.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary text-xxs rounded">Delete Member(s)</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</teleport>
